import React, { useState } from 'react';
import { Col, Row, Image, Button, Modal } from 'react-bootstrap';
import ADD from '../../../assets/images/ic-add.svg';
import Dot from '../../../assets/images/ic-3dot.svg';
import { GetDeleteCVCompanyRecords } from '../../../features/learning/deleteCompanyRecordsSlice';
import { useAppDispatch } from '../../../app/hooks';
import { isAdmin } from '../../../features/localStorage';
import swal from 'sweetalert';
import { GetInsertCompanyGroup } from '../../../features/learning/insertCompanyGroupSlice';
import { GetUpdateCompanyGroup } from '../../../features/learning/updateCompanyGroup';
import { GetCodeOfVoilationModule } from '../../../features/learning/CodeOfVoilationSlice';
import EmptyRow from '../../../components/emptyRow/EmptyRow';
import ENGModalHeader from '../../../components/modal/ENGModalHeader';
import ENGModalBody from '../../../components/modal/ENGModalBody';
import ModalDelete from '../../../assets/images/delete-bin-line.svg';
const EditAccordionTable = ({
  data,
  title,
  id
}: {
  data: any;
  title: any;
  id: any;
}) => {
  const dispatch = useAppDispatch();
  const [row, setRow] = useState<string>();
  // const id = data[data.length-1].id;
  const addRow = () => {
    const add = 'true';
    setRow(add);
  };

  const [brief, setbrief] = useState('');
  const [clause, setclause] = useState('');
  const [actionTaken, setactionTaken] = useState('');
  const [onEditFlag, setonEditFlag] = useState(false);
  const [compGroupId, setcompGroupId] = useState();
  const userDetails = localStorage.getItem('userDetails');
  const userDetailsList: any = userDetails;
  const userDetailsJson = JSON.parse(userDetailsList);
  const [modalShow1, setModalShow1] = useState(false);
  const handleClose1 = () => setModalShow1(false);
  const [deleteDetails, setDeleteDetails] = useState<any>();
  const onEditCompanyRecords = async (item: any) => {
    // console.log(item)
    setonEditFlag(true);
    setcompGroupId(item.id);
  };
  const onDeleteModalShow = (item: any) => {
    setModalShow1(true);
    setDeleteDetails(item);
  };
  const onDeleteCompanyRecords = async () => {
    await dispatch(GetDeleteCVCompanyRecords(deleteDetails.id));
    await dispatch(GetCodeOfVoilationModule());
    await setModalShow1(false);
    await window.location.reload();
  };
  const handleSubmit = async (event: any) => {
    event.preventDefault();
    var postdata = {
      groupName: title,
      brief: brief,
      clause: clause,
      actionTaken: actionTaken,
      companyId: userDetailsJson.companyId,
      eng_code_of_violation_group_id: id
    };
    var data = {
      data: postdata,
      id: id
    };
    await dispatch(GetInsertCompanyGroup(data));
    dispatch(GetCodeOfVoilationModule());
    setbrief('');
    setclause('');
    setactionTaken('');
    // handleClose();
  };
  const handleEditSubmit = async (event: any) => {
    event.preventDefault();
    var postdata = {
      groupName: title,
      brief: brief,
      clause: clause,
      actionTaken: actionTaken,
      companyId: userDetailsJson.companyId,
      eng_code_of_violation_group_id: id
    };
    var data = {
      data: postdata,
      id: compGroupId
    };
    await dispatch(GetUpdateCompanyGroup(data));
    dispatch(GetCodeOfVoilationModule());
    await window.location.reload();
    // handleClose();
  };

  return (
    <>
      {data.length > 0 ? (
        data.map((val: any, index: any) => {
          return (
            <>
              <form onSubmit={handleEditSubmit}>
                <Row>
                  <div style={styles.line}></div>
                </Row>
                <Row style={{ paddingTop: '18px', paddingBottom: '18px' }}>
                  <Col sm={2} style={styles.id} className='desk'>
                    {index + 1}.
                  </Col>

                  <Col sm={4} style={styles.data}>
                    {onEditFlag !== true ? (
                      <p>{val?.brief}</p>
                    ) : (
                      <textarea
                        style={styles.data}
                        className='shadow-none form-control'
                        defaultValue={val?.brief}
                        rows={5}
                        onChange={(
                          ev: React.ChangeEvent<HTMLTextAreaElement>
                        ): void => setbrief(ev.target.value)}
                        placeholder='Add brief'
                      ></textarea>
                    )}
                  </Col>
                  <Col sm={2} style={styles.data}>
                    {onEditFlag !== true ? (
                      <p>{val?.clause}</p>
                    ) : (
                      <input
                        type='text'
                        style={styles.data}
                        className='shadow-none'
                        defaultValue={val?.clause}
                        onChange={(
                          ev: React.ChangeEvent<HTMLInputElement>
                        ): void => setclause(ev.target.value)}
                        placeholder='Add clause'
                      />
                    )}
                  </Col>
                  <Col sm={3} style={styles.data}>
                    {onEditFlag !== true ? (
                      <p>{val?.actionTaken}</p>
                    ) : (
                      <input
                        type='text'
                        style={styles.data}
                        className='shadow-none'
                        defaultValue={val?.actionTaken}
                        onChange={(
                          ev: React.ChangeEvent<HTMLInputElement>
                        ): void => setactionTaken(ev.target.value)}
                        placeholder='Add actionTaken'
                      />
                    )}
                  </Col>
                  <Col sm={1}>
                    {isAdmin() && (
                      <div className='dropdown'>
                        <Image src={Dot} className='threedot' />
                        <div className='dropdown-content'>
                          <p>
                            <a
                              href='#'
                              onClick={() => onEditCompanyRecords(val)}
                            >
                              Edit
                            </a>
                          </p>
                          <p>
                            <a href='#' onClick={() => onDeleteModalShow(val)}>
                              Delete
                            </a>
                          </p>
                        </div>
                      </div>
                    )}
                  </Col>
                </Row>
                {onEditFlag !== true ? null : (
                  <Row className='marb-mob0-desk16'>
                    <Col sm={2}></Col>
                    <Col sm={6} style={styles.add} className='desk'></Col>
                    <Col sm={2}>
                      <Button id='gdgddghg' type='submit' style={styles.button}>
                        Save
                      </Button>
                    </Col>
                  </Row>
                )}
              </form>
            </>
          );
        })
      ) : (
        <span style={styles.text1}>You have not declared anything.</span>
      )}
      <form onSubmit={handleSubmit}>
        {row && (
          <div>
            {onEditFlag !== true ? (
              <div>
                <Row>
                  <div style={styles.line}></div>
                </Row>
                <Row style={{ paddingTop: '18px', paddingBottom: '18px' }}>
                  <Col sm={2} style={styles.id} className='desk'></Col>
                  <Col sm={4}>
                    <input
                      type='text'
                      style={styles.data}
                      className='shadow-none'
                      value={brief}
                      onChange={(
                        ev: React.ChangeEvent<HTMLInputElement>
                      ): void => setbrief(ev.target.value)}
                      placeholder='Add details'
                    />
                  </Col>
                  <Col sm={2}>
                    <input
                      type='text'
                      style={styles.data}
                      className='shadow-none'
                      value={clause}
                      onChange={(
                        ev: React.ChangeEvent<HTMLInputElement>
                      ): void => setclause(ev.target.value)}
                      placeholder='Add clause'
                    />
                  </Col>
                  <Col sm={2}>
                    <input
                      type='text'
                      style={styles.data}
                      className='shadow-none'
                      value={actionTaken}
                      onChange={(
                        ev: React.ChangeEvent<HTMLInputElement>
                      ): void => setactionTaken(ev.target.value)}
                      placeholder='Add action taken'
                    />
                  </Col>
                </Row>
              </div>
            ) : null}
          </div>
        )}
        {isAdmin() && (
          <div>
            {onEditFlag !== true ? (
              <Row className='marb-mob0-desk16'>
                <Col sm={2}></Col>
                <Col
                  sm={6}
                  style={styles.add}
                  onClick={addRow}
                  className='desk'
                >
                  <Image src={ADD} />
                  ADD ROW
                </Col>
                {row && (
                  <Col sm={2}>
                    <Button type='submit' style={styles.button}>
                      Save
                    </Button>
                  </Col>
                )}
              </Row>
            ) : null}
          </div>
        )}
      </form>
      <Modal
        show={modalShow1}
        onHide={handleClose1}
        backdrop='static'
        size='lg'
        keyboard={false}
      >
        <ENGModalHeader icon={ModalDelete} title=' Delete Module ' />
        <ENGModalBody
          contents={
            <>
              <Row style={styles.divWhite}>
                <Col lg={12}>
                  <p style={styles.delcontent}>
                    Are you sure you want delete this module?
                  </p>
                </Col>
              </Row>
            </>
          }
        />
        <EmptyRow />
        <EmptyRow />
        <EmptyRow />
        <EmptyRow />
        <Row style={styles.divGrey}>
          <Col sm={9}></Col>
          <Col sm={3}>
            <button
              type='button'
              className='mr-2'
              onClick={handleClose1}
              style={styles.button1}
            >
              {' '}
              CANCEL{' '}
            </button>
            <button
              className='ml-2'
              type='button'
              onClick={onDeleteCompanyRecords}
              style={styles.button}
            >
              {' '}
              DELETE{' '}
            </button>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

const styles: any = {
  button: {
    padding: '10px 40px',
    fontFamily: 'Saira',
    fontSize: '12px',
    fontWeight: 400,
    fontStretch: 'normal',
    fontStyle: 'normal',
    borderRadius: '0',
    backgroundColor: '#e31837',
    letterSpacing: 'normal',
    border: '0px',
    float: 'right'
  },
  button1: {
    padding: '13px 20px',
    fontFamily: 'Saira',
    fontSize: '12px',
    fontWeight: '500',
    fontStretch: 'normal',
    fontStyle: 'normal',
    borderRadius: '0',
    backgroundColor: '#ffffff',
    border: '1px solid #e31837',
    letterSpacing: 'normal',
    color: '#e31837'
  },
  divGrey: {
    backgroundColor: 'rgb(250, 249, 249)',
    paddingTop: '20px',
    margin: '0px',
    paddingLeft: '10px',
    paddingRight: '10px',
    paddingBottom: '20px',
    borderTop: '1px solid #eee;'
  },
  id: {
    fontFamily: 'Saira',
    fontSize: '12px',
    fontWeight: '500',
    color: '#242424',
    paddingLeft: '54px'
  },
  idmob: {
    fontFamily: 'Saira',
    fontSize: '12px',
    fontWeight: '600',
    color: '#e31837',
    border: 'solid 2px #e31837',
    height: '30px',
    width: '30px',
    textAlign: 'center',
    borderRadius: '15px',
    lineHeight: '2.2'
  },
  heading: {
    fontFamily: 'Saira',
    fontSize: '14px',
    fontWeight: '600',
    color: 'black',
    marginBottom: '4px'
  },
  data: {
    fontFamily: 'Saira',
    fontSize: '12px',
    fontWeight: '500',
    color: 'black'
  },
  add: {
    fontFamily: 'Saira',
    fontSize: '12px',
    fontWeight: '600',
    color: '#e31837'
  },
  text1: {
    fontFamily: 'Saira',
    fontSize: '16px',
    fontWeight: 'normal',
    border: 'solid 1px #e4e4e4',
    borderTop: '0px',
    borderLeft: '0px',
    borderRight: '0px',
    color: '#6d6e71',
    textAlign: 'center'
  },
  line: {
    height: '1px',
    margin: '0px',
    backgroundColor: '#ededed'
  }
};

export default EditAccordionTable;
